import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Company Info - Full width on mobile */}
        <div className="mb-8 md:hidden">
          <div className="flex items-center space-x-2 mb-4">
            <div className="h-8 flex items-center justify-center">
              <img className="h-8" src='/Flote_Word_Red.png' alt='Flote' />
            </div>
          </div>
          <p className="text-gray-600">
            Montana's trusted source for top-quality, locally-sourced wholesale cannabis products.
          </p>
        </div>

        {/* Mobile: 2 columns for Quick Links and Contact, Desktop: 3 columns */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
          {/* Company Info - Hidden on mobile, shown on desktop */}
          <div className="hidden md:block">
            <div className="flex items-center space-x-2 mb-4">
            <div className="h-8 flex items-center justify-center">
              <img className="h-8" src='/Flote_Word_Red.png' alt='Flote' />
            </div>
            </div>
            <p className="text-gray-600">
              Montana's trusted source for top-quality, locally-sourced wholesale cannabis products.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gray-900 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/brands" className="text-gray-600 hover:text-gray-900 transition-colors inline-block">
                  Brands
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-600 hover:text-gray-900 transition-colors inline-block">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-gray-900 transition-colors inline-block">
                  Terms and Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-gray-900 mb-4">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a href="https://maps.google.com/?q=512+N+Broadway+Ave+Bozeman+MT+59715" target="_blank" rel="noopener noreferrer" className="inline-flex items-start space-x-2 text-gray-600 hover:text-gray-900 transition-colors">
                  <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span>
                    512 N Broadway Ave<br />
                    Bozeman, MT 59715<br />
                    United States
                  </span>
                </a>
              </li>
              <li>
                <a href="tel:+14062008524" className="inline-flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors">
                  <Phone className="w-5 h-5" />
                  <span>(406) 200-8524</span>
                </a>
              </li>
              <li>
                <a href="mailto:hello@withflote.com" className="inline-flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors">
                  <Mail className="w-5 h-5" />
                  <span>hello@withflote.com</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-4">
            <p className="text-gray-500">
              © {currentYear} Flote. All rights reserved.
            </p>
            <Link to="/terms" className="text-gray-500 hover:text-gray-900 transition-colors">
              Terms of Service
            </Link>
          </div>
          <p className="text-xs text-gray-400 mt-4 text-center sm:text-left">
            All products have been tested and meet the requirements of the state of Montana. Keep out of reach of children and pets. These products may be addictive. These products may have intoxicating effects. Do not drive while under the influence of marijuana.
          </p>
        </div>
      </div>
    </footer>
  );
}
